import { useCallback, useEffect, useState } from 'react';
import { getPickUpReserveListApi } from '@/api/bodyAndPaint';
import { PickUpReserveListResponse } from '@/types/api/bodyAndPaint';

interface GetPickUpReserveListHookProps {
  plantID: number;
  inspectionID: number;
}
export const useGetPickUpReserveListApi = ({
  plantID,
  inspectionID,
}: GetPickUpReserveListHookProps) => {
  const [PickUpReserveListData, setPickUpReserveListData] =
    useState<PickUpReserveListResponse>({} as PickUpReserveListResponse);

  const fetchDate = useCallback(async () => {
    try {
      if (plantID > 0) {
        const fetch = await getPickUpReserveListApi({
          m_plant_id: plantID,
          t_pm_car_inspection_id: inspectionID,
        });
        setPickUpReserveListData(fetch?.data);
      } else {
        setPickUpReserveListData({} as PickUpReserveListResponse);
        throw 'invalid parameter';
      }
    } catch (error) {
      console.error(error);
    }
  }, [plantID]);
  useEffect(() => {
    fetchDate();
  }, [fetchDate]);

  return { PickUpReserveListData };
};
